<div *ngIf="item.type === 'dropdown'" class="item-list">

  <div class="title">
    <button class="btn btn-link btn-block text-left p-0" (click)="close($event)">
      <i class="fa fa-arrow-left"></i>
    </button>
    {{item?.label}}
  </div>

  <div class="input-group search-keywords" [hidden]="item.hideSearch">
    <div class="input-group-prepend">
      <img src="/assets/images/icon-search-keywords.svg" alt="Search Icon" />
    </div>
    <input autofocus type="text" class="form-control search-keywords" [debounce]="500" [(ngModel)]="item.searchString"
      placeholder="Input..." aria-describedby="basic-addon2" (onDebounce)="showOptions(item)" />
  </div>

  <div [attr.class]="'items-cont '+item.param">
    <ul>
      <li *ngFor="let option of item.options">
        <a [ngClass]="{'selected': isSelectedFilter(item, option), 'disabled': !noFacets && (!facets || !facets[item.param] || !facets[item.param][option.value])}"
          (click)="onDropdownFilterSelect(item, option, $event)">
          <img class="check-icon" src="/assets/images/icon-indicator-check.png" alt="Check Icon" />

          <img *ngIf="option.icon && option.icon.length > 0" [attr.src]="option.icon"
            onerror="this.style.opacity=0;this.style.fontSize=0;" width="16" height="16" alt="{{option.text}} Icon" />

          <span [innerHTML]="option.text"></span>
          &nbsp;
          <span class="facet"
            *ngIf="!noFacets && facets && facets[item.param] && facets[item.param][option.value] >= 0">
            ({{facets[item.param][option.value] | num}})
          </span>
          <span class="facet"
            *ngIf="!noFacets && (!facets || !facets[item.param] || !facets[item.param][option.value])">(0)</span>
        </a>
      </li>
    </ul>
    <a [hidden]="!item.optionsLoading" class="btn btn-link btn-sm btn-block text-xs-center disabled">
      <i class="fa fa-spinner fa-spin fa-fw"></i>
      <span class="sr-only">Loading...</span>
      <span [hidden]="item.optionsLoading" *ngIf="item.options.length <= 0" class="no-results-found">No results
        found.</span>
    </a>
  </div>

</div>

<pix-dropdown-range-slider3 [disabled]="loadingData" *ngIf="item.type === 'range'" [tab]="'siteinfo'"
  [title]="item.label" [iconHtml]="''" [initMaxValue]="item.initMaxValue" [(minValue)]="item.minValue"
  (close)="close($event)" [(maxValue)]="item.maxValue" [(fromValue)]="item.fromValue" [(toValue)]="item.toValue"
  [step]="item.rangeStep" [isPercent]="item.rangePercent" [param]="item.param"
  (onRangeChanged)="onRangeChanged(item, $event)"></pix-dropdown-range-slider3>

<pix-dropdown-rating-filter3 [disabled]="loadingData" [facets]="facets" *ngIf="item.type === 'rating'"
  [items]="item.options" [tab]="'siteinfo'" [noFacets]="noFacets" (close)="close($event)" [param]="item.param"
  [title]="item.label" [isMultiple]="true" (onRangeChanged)="onRangeChanged(item, $event)"
  (onRemoveFilterItem)="onRangeChanged(item, $event)"></pix-dropdown-rating-filter3>